import api from '@app/api/routes/api';
import type { MceEventsFilters, PaginatedMceEventsResponse } from './mceEvents.types';

/**
 * Récupère la liste paginée et triée des événements MCE centralisés.
 * Source unique pour la timeline (FormEntry + Clocking PDS/FDS + futurs événements).
 */
export const getMceEvents = async (filters?: MceEventsFilters): Promise<PaginatedMceEventsResponse> => {
  const params = new URLSearchParams();
  filters?.event_types?.forEach((type) => params.append('event_types[]', type));
  filters?.site_ids?.forEach((id) => params.append('site_ids[]', String(id)));
  filters?.form_uids?.forEach((uid) => params.append('form_uids[]', uid));
  filters?.group_ids?.forEach((id) => params.append('group_ids[]', String(id)));
  filters?.importances?.forEach((v) => params.append('importances[]', String(v)));
  if (filters?.site_id) params.append('site_id', String(filters.site_id));
  if (filters?.user_id) params.append('user_id', String(filters.user_id));
  if (filters?.form_id) params.append('form_id', String(filters.form_id));
  if (filters?.category_id) params.append('category_id', String(filters.category_id));
  if (filters?.status) params.append('status', filters.status);
  if (filters?.started_from) params.append('started_from', filters.started_from);
  if (filters?.started_to) params.append('started_to', filters.started_to);
  if (filters?.search) params.append('search', filters.search);
  if (filters?.per_page) params.append('per_page', String(filters.per_page));
  if (filters?.page) params.append('page', String(filters.page));

  const query = params.toString();
  return api.getRaw<PaginatedMceEventsResponse>(`/mce/events${query ? `?${query}` : ''}`);
};
